<h2 class="mat-h2">{{ visibleData.Title }}</h2>
<p class="mat-body-2">{{ visibleData.Description }}</p>
<span class="mat-caption">{{ visibleData.Hint }}</span>

<div class="actions"
    [ngClass]="{ 'xtra-btn' : secondConfirmation }">

    <div [ngClass]="{ 'col-1': !secondConfirmation, 'col-0': secondConfirmation}">
        <button mat-button
            mat-stroked-button
            id="double-confirm-dialog-cancel"
            (click)="cancel()">
            {{ 'default.cancel' | blah | uppercase }}
        </button>
    </div>

    <div *ngIf="secondConfirmation"
        class="col-2">
        <button mat-button
            mat-stroked-button
            id="double-confirm-dialog-no"
            [type]="'raised'"
            (click)="submitWithOptions(false)">
            {{ 'default.no' | blah | uppercase }}
        </button>
    </div>
    <div *ngIf="secondConfirmation"
        class="col-3">
        <button mat-button
            mat-flat-button
            color="warn"
            id="double-confirm-dialog-yes"
            [type]="'raised'"
            (click)="submitWithOptions(true)">
            {{ 'default.yes' | blah | uppercase }}
        </button>
    </div>
    <div *ngIf="!secondConfirmation"
        class="col-2">
        <button mat-button
            mat-flat-button
            color="warn"
            id="double-confirm-dialog-action"
            [type]="'raised'"
            (click)="submit()">
            {{ dialogData.Action | uppercase }}
        </button>
    </div>
</div>